(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-buying-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const slugify = (text) => text.toLowerCase().trim().replace(/[^a-z0-9\s-]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');

    const initToc = (section) => {
      if (!section || section.dataset.articleTocInitialized === 'true') return;

      const content = section.querySelector('[data-article-content]');
      const tocList = section.querySelector('[data-toc-list]');
      const toc = tocList ? tocList.closest('[data-toc]') : null;

      if (!content || !tocList) return;

      const headings = Array.from(content.querySelectorAll('h2'));

      const ids = new Set();

      headings.forEach((heading, index) => {
        if (!heading.id) {
          const baseId = slugify(heading.textContent) || `section-${index + 1}`;
          let nextId = baseId;
          let count = 2;

          while (ids.has(nextId) || document.getElementById(nextId)) {
            nextId = `${baseId}-${count}`;
            count += 1;
          }

          heading.id = nextId;
        }

        ids.add(heading.id);
      });

      if (!tocList.children.length && headings.length) {
        headings.forEach((heading) => {
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = `#${heading.id}`;
          link.textContent = heading.textContent.trim();
          item.append(link);
          tocList.append(item);
        });
      }

      if (tocList.children.length && toc) {
        toc.hidden = false;
      } else if (toc) {
        toc.hidden = true;
        return;
      }

      const links = Array.from(tocList.querySelectorAll('a[href^="#"]'));
      const linkedHeadings = links
        .map((link) => {
          const id = decodeURIComponent(link.getAttribute('href').slice(1));
          return document.getElementById(id);
        })
        .filter(Boolean);

      if (!linkedHeadings.length) return;

      section.dataset.articleTocInitialized = 'true';

      const setActive = (id) => {
        links.forEach((link) => {
          link.classList.toggle('is-active', link.getAttribute('href') === `#${id}`);
        });
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActive(entry.target.id);
          }
        });
      }, { rootMargin: '-28% 0px -62% 0px', threshold: 0.01 });

      linkedHeadings.forEach((heading) => {
        observer.observe(heading);
      });
    };

    const initAllTocs = () => {
      document.querySelectorAll('[data-article-buying-guide]').forEach(initToc);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllTocs, { once: true });
    } else {
      initAllTocs();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initToc(event.target.querySelector('[data-article-buying-guide]') || event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
